var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('BotaoDaTelaDeProcessos'),_c('BotaoDeNotificacao'),_c('DialogoDeDownload'),_c('Help'),_c('DialogoDeConfiguracaoDePerfil'),_c('AvisoDeNotificacao')],1)}
var staticRenderFns = []

export { render, staticRenderFns }